
import PixelatedCanvas from "./PixelatedCanvas";

export default function AboutUs() {
  return (
    <section id="nosotros" className="relative py-16">
      
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        style={{
          background: `
            radial-gradient(1200px 520px at 8% -10%, rgba(32,75,151,.10), transparent 65%),
            radial-gradient(1400px 600px at 100% -10%, rgba(93,131,243,.12), transparent 70%),
            radial-gradient(1200px 520px at 50% 110%, rgba(64,196,198,.10), transparent 70%)
          `,
        }}
      />

      <div className="mx-auto max-w-6xl px-4">
        {/* TARJETAA */}
        <div className="relative overflow-hidden rounded-3xl bg-white ring-1 ring-black/5 shadow-[0_24px_70px_rgba(15,23,42,0.12)]">
          <div className="grid items-center gap-10 p-8 md:p-12 md:grid-cols-2">
            
            <div
              className="
                max-w-[520px] w-full
                rounded-[32px]
                border border-slate-200/60
                bg-white/40 backdrop-blur-xl
                shadow-[0_18px_45px_rgba(15,23,42,0.08)]
                flex items-center justify-center
                mx-auto
              "
            >
              <PixelatedCanvas
                src="/img/zentra5.png"
                width={520}
                height={520}
                cellSize={4}
                dotScale={0.9}
                shape="square"
                backgroundColor="transparent"
                interactive
                distortionStrength={3}
                distortionRadius={120}
                jitterStrength={3}
                jitterSpeed={3}
                className="block w-full h-full rounded-[32px]"
              />
            </div>

            
            <div className="order-1 md:order-2">
              <span className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-3 py-1 text-sm text-slate-700 backdrop-blur">
                Nosotros
                <span
                  className="h-2 w-2 rounded-full"
                  style={{ background: "#36C0B9" }}
                />
              </span>

              <h2 className="heading-display mt-4 text-4xl md:text-5xl font-bold text-slate-900">
                Sobre nosotros
              </h2>

              <p className="mt-3 max-w-xl text-slate-600">
                En Zentra Group unimos el{" "}
                <strong>desarrollo de sistemas web a medida</strong> con la{" "}
                <strong>gestión inteligente de flotas en tiempo real</strong>.
                A través de <strong>Zentra Sistemas</strong> y{" "}
                <strong>Zentra GPS</strong> ayudamos a las empresas a
                digitalizar sus procesos, ganar visibilidad sobre la operación y
                tomar mejores decisiones basadas en datos.
              </p>

              <ul className="mt-6 grid gap-3 text-slate-700">
                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204B97" }}
                  />
                  Desarrollo de sistemas y automatizaciones.
                </li>
                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204B97" }}
                  />
                  Integraciones (ERPs/CRMs, pagos, APIs).
                </li>
                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204B97" }}
                  />
                  Monitoreo de flotas en tiempo real.
                </li>
                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204B97" }}
                  />
                  Acompañamiento y mejora continua.
                </li>
              </ul>

           
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
